import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Switch from '@prism/switch';
import '@prism/styles/prism/switch.css';

class PrismSwitch extends React.PureComponent {
    static propTypes = {
        className: PropTypes.string,
        status: PropTypes.bool,
        label: PropTypes.string,
        disabled: PropTypes.bool,
        onChange: PropTypes.func,
        labelAlignment: PropTypes.string,
    };

    render() {
        const {
            className,
            status,
            label,
            disabled,
            labelAlignment,
            statusText,
            showTooltip,
            tooltipContent,
            id,
            ...elementProps
        } = this.props;

        const elementClassName = classNames(
            'prism-switch custom-backkground-switch',
            className
        );

        let statusCurrent = this.props?.status;

        const onChange = () => {
            statusCurrent = !statusCurrent;
            if (this.props?.onChange) {
                this.props.onChange(statusCurrent);
            }
        }

        const tooltipText = disabled === true ? tooltipContent : '';

        return (
            <div className= {elementClassName} id={id} data-toggle="tooltip" title={tooltipText}>
                <Switch
                    {...elementProps}
                    className={'prism-switch'}
                    label={label}
                    disabled={disabled}
                    statusText={statusText}
                    labelAlignment={labelAlignment}
                    onChange={onChange}
                    status={statusCurrent}
                />
            </div>
        );
    }
}

export default PrismSwitch;
